import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { SplitButton } from "primereact/splitbutton";
import { TreeTable } from "primereact/treetable";

import React, { useEffect, useState } from "react";
import CardSeplag from "../../../components/CardSeplag";
import ModalSeplag from "../../../components/ModalSeplag";
import RotuloSeplag from "../../../components/RotuloSeplag";
import { printToast } from "../../../config/global";
import {
  adicionarPermissao,
  adicionarPermissaoUoPrograma,
  buscarPermissoesItem,
  removerPermissaoUsuario,
} from "../../../service/Monitora/Permissoes";

import { carregarArvoreMonitora, carregarArvoreMonitoraComFiltro } from "../../../service/ArvoreMonitora";
import { pesquisarPorId } from "../../../service/Monitora/Lancamentos";
import { buscarPorNomeEmailCpf } from "../../../service/seguranca/usuario/contaAcesso";

import SelectableTreeNode from "./SelectTableTreeNode";
import "./style.css";

const MonitoraPermissoes = () => {
  const [ptaMonitoraSelecionado, setPtaMonitoraSelecionado] = useState();

  const [cDadosArvore, setCDadosArvore] = useState([]);
  const [cDadosExercicios, setCDadosExercicios] = useState([]);
  const [cDadosCiclo, setCDadosCiclo] = useState([]);
  const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
  const [cDadosUOs, setCDadosUOs] = useState([]);
  const [cDadosProgramas, setCDadosProgramas] = useState([]);

  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState();
  const [usuarioSelecionadoName, setUsuarioSelecionadoName] = useState("");

  const [programaSelecionado, setProgramaSelecionado] = useState(null);
  const [uoSelecionada, setUoSelecionada] = useState(null);
  const [orgaoSelecionado, setOrgaoSelecionado] = useState([]);
  const [exercicioSelecionado, setExercicioSelecionado] = useState([]);
  const [exibirBuscaUsuario, setExibirBuscaUsuario] = useState(false);
  const [inputBusca, setInputBusca] = useState("");
  const [messagemUsuarioBusca, setMessagemUsuarioBusca] = useState(null);
  const [usuariosBusca, setUsuariosBusca] = useState(null);
  const [first, setFirst] = useState(0);
  const [rows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);

  //const [items, setItems] = useState()
  const items = [
    {
      label: "Por item",
      icon: "pi pi-eye",
      command: (e) => {
        addPermissao("V");
      },
    },
    {
      label: "Por Programa",
      icon: "pi pi-eye",
      command: () => {
        addPermissaoProgramaUO("V", "P");
      },
    },
    {
      label: "Por UO",
      icon: "pi pi-eye",
      command: () => {
        addPermissaoProgramaUO("V", "UO");
      },
    },
  ];
  const itemsEdicao = [
    {
      label: "Por item",
      icon: "pi pi-pencil",
      command: (e) => {
        addPermissao("E");
      },
    },
    {
      label: "Por Acao",
      icon: "pi pi-pencil",
      command: () => {
        addPermissao("E");
      },
    },
    {
      label: "Por Programa",
      icon: "pi pi-pencil",
      command: () => {
        addPermissaoProgramaUO("E", "P");
      },
    },
  ];

  const [filtro] = useState(false);

  const [selectedNodeKeys, setSelectedNodeKeys] = useState([]);

  useEffect(() => {
    carregarArvoreMonitora().then((res) => {
      montarArvore(res);
      if (!filtro) {
        setExercicioSelecionado(res.listaExercicios[0]);
        setOrgaoSelecionado(res.orgaoFiplans[0]);
        setUoSelecionada(res.unidadeOrcamentarias[0]);
        setProgramaSelecionado(res.programas[0]);
      }
    });
    setLoading(false);
  }, [filtro]);

  function montarArvore(dadosArvore) {
    if (dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
      setCDadosArvore(dadosArvore.arvorePtaMonitoras);
    } else {
      setCDadosArvore({ content: { key: null, statusItem: null, tipoItemPta: null } });
    }
    setCDadosExercicios(dadosArvore != null ? dadosArvore.listaExercicios : null);
    setCDadosCiclo(
      dadosArvore && dadosArvore.parametroExercicio
        ? dadosArvore.parametroExercicio
        : { cicloMonitoramento: { statusCiclo: "" } }
    );
    setCDadosOrgaos(dadosArvore != null ? dadosArvore.orgaoFiplans : null);
    setCDadosUOs(dadosArvore != null ? dadosArvore.unidadeOrcamentarias : null);
    setCDadosProgramas(dadosArvore != null ? dadosArvore.programas : null);
  }

  let defaultArvoreMonitora = {
    arvorePtaMonitoras: cDadosArvore,
    listaExercicios: cDadosExercicios,
    parametroExercicio: cDadosCiclo,
    orgaoFiplans: cDadosOrgaos,
    unidadeOrcamentarias: cDadosUOs,
    programas: cDadosProgramas,
  };

  const onChangeExercicio = (e) => {
    setExercicioSelecionado(e.value);
    setOrgaoSelecionado(null);
    setUoSelecionada(null);
    setProgramaSelecionado(null);
    setCDadosOrgaos(null);
    setCDadosUOs(null);
    setCDadosProgramas(null);
    setCDadosArvore(null);
    let filtro = {
      idenExercicio: e.value.idenExercicio,
      idenOrgao: null,
      idenUo: null,
      idenPrograma: null,
    };
    carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, false, 0, 10).then((res) => {
      montarArvore(res);
    });
  };
  const onChangeOrgao = (e) => {
    setOrgaoSelecionado(e.value);
    setUoSelecionada(null);
    setProgramaSelecionado(null);
    setCDadosUOs(null);
    setCDadosProgramas(null);
    setCDadosArvore(null);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: e.value.idenOrgao,
      idenUo: null,
      idenPrograma: null,
    };
    carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
    });
  };
  const onChangeUo = (e) => {
    setUoSelecionada(e.value);
    setProgramaSelecionado(null);
    setCDadosProgramas(null);
    setCDadosArvore(null);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: orgaoSelecionado.idenOrgao,
      idenUo: e.value.idenUo,
      idenPrograma: null,
    };
    carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, false, 0, 10).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
      setCDadosProgramas(res.programas);
    });
  };
  const onChangePrograma = (e) => {
    setProgramaSelecionado(e.value);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: orgaoSelecionado.idenOrgao,
      idenUo: uoSelecionada.idenUo,
      idenPrograma: e.value.idenPrograma,
    };
    carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, false, 0, 10).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
      setCDadosProgramas(res.programas);
      setTotalRecords(res.arvorePtaMonitoras.totalElements);
      if (res.arvorePtaMonitoras != null) {
        setCDadosArvore(res.arvorePtaMonitoras);
      } else {
        setCDadosArvore(null);
      }
    });
  };
  const carregarPermissoes = (event) => {
    let idenPtaMonitora = event.node ? event.node.idenPtaMonitora : event.idenPtaMonitora;
    buscarPermissoesItem(idenPtaMonitora, 0, 10).then((res) => {
      setUsuarios(res);
    });
  };

  function buscarPtaMonitora(idenPtaMonitora) {
    pesquisarPorId(idenPtaMonitora).then((res) => {
      setPtaMonitoraSelecionado(res);
    });
  }
  function abrirBuscaUsuario() {
    setExibirBuscaUsuario(true);
  }

  function buscarUsuario(page, size) {
    if (inputBusca === null || inputBusca.length === 0) {
      printToast({ severity: "error", summary: "Erro na validação", detail: "Informe ao menos um critério de busca" });
    } else if (inputBusca.length < 3) {
      printToast({
        severity: "error",
        summary: "Erro na validação",
        detail: "O texto a ser pesquisado deve ter ao menos 3 (três) caracteres",
      });
    } else {
      let postBody = {
        nome: inputBusca,
        pesquisarTodoNome: true,
      };
      buscarPorNomeEmailCpf(postBody, page, size).then((res) => {
        setUsuariosBusca(res);
        if (res.content.length === 0) {
          setMessagemUsuarioBusca(true);
        }
      });
    }
  }

  function buscarCdadosArvore(visoesPage, visoesSize) {
    setFirst(visoesPage);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: orgaoSelecionado.idenOrgao,
      idenUo: uoSelecionada.idenUo,
      idenPrograma: programaSelecionado.idenPrograma,
    };
    carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora, false, visoesPage, visoesSize).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
      setCDadosProgramas(res.programas);
      if (res.arvorePtaMonitoras != null) {
        setCDadosArvore(res.arvorePtaMonitoras);
        setTotalRecords(res.arvorePtaMonitoras.totalElements);
      } else {
        setCDadosArvore(null);
      }
    });
  }
  async function adicionarPermissaoAsync(postBody) {
    try {
      return await adicionarPermissao(postBody);
    } catch (err) {
      return printToast({
        severity: "error",
        summary: "Erro ao Adicionar Permissao",
        detail: err,
      });
    }
  }

  async function addPermissao(tipoPermissao) {
    if (ptaMonitoraSelecionado) {
      if (usuarioSelecionado) {
        try {
          for (const idenPtaMonitora of selectedNodeKeys) {
            let postBody = {
              contaAcesso: {
                id: usuarioSelecionado.id,
              },
              exercicio: {
                idenExercicio: ptaMonitoraSelecionado.ptaFiplan.exercicio.idenExercicio,
              },
              sistema: {
                idenSistema: 4,
              },
              ptaMonitora: {
                idenPtaMonitora,
              },
              flagTipoPermissao: tipoPermissao,
              statPermissaoPtaMonitora: 1,
            };

            await adicionarPermissaoAsync(postBody);
          }
          carregarPermissoes(ptaMonitoraSelecionado);
          printToast({ severity: "success", summary: "Concluído", detail: "Permissão inserida com Sucesso" });
        } catch (err) {
          return printToast({ severity: "error", summary: "Erro", detail: "Erro ao adicionar permissão" });
        }

        return null;
      } else {
        return printToast({
          severity: "error",
          summary: "Erro na validação",
          detail: "Selecione um usuário para adicionar a permissão",
        });
      }
    } else {
      return printToast({
        severity: "error",
        summary: "Erro na validação",
        detail: "Selecione um item da Árvore do PTA para adicionar uma permissão",
      });
    }
  }

  async function removerPermissaoAsync(postBody) {
    try {
      return await removerPermissaoUsuario(postBody);
    } catch (err) {
      return printToast({
        severity: "error",
        summary: "Erro ao Adicionar Permissao",
        detail: err,
      });
    }
  }
  async function rmvPermissao() {
    if (ptaMonitoraSelecionado && selectedNodeKeys.length > 0) {
      if (usuarioSelecionado) {
        try {
          for (const idenPtaMonitora of selectedNodeKeys) {
            let postBody = {
              contaAcesso: {
                id: usuarioSelecionado.contaAcesso.id,
              },
              exercicio: {
                idenExercicio: ptaMonitoraSelecionado.ptaFiplan.exercicio.idenExercicio,
              },
              sistema: {
                idenSistema: 4,
              },
              ptaMonitora: {
                idenPtaMonitora: idenPtaMonitora,
              },
              flagTipoPermissao: "E",
              statPermissaoPtaMonitora: usuarioSelecionado.contaAcesso.statPermissaoPtaMonitora,
              flagExclusao: "S",
              flagExclusaoPai: "S",
            };

            await removerPermissaoAsync(postBody);

            carregarPermissoes(ptaMonitoraSelecionado);
            printToast({
              severity: "success",
              summary: "Concluído",
              detail: "Permissão do usuário removida com Sucesso",
            });
          }
        } catch (err) {
          return printToast({ severity: "error", summary: "Erro", detail: "Erro ao adicionar permissão" });
        }

        return null;
      } else {
        return printToast({
          severity: "error",
          summary: "Erro na validação",
          detail: "Selecione um usuário para remover a permissão",
        });
      }
    } else {
      return printToast({
        severity: "error",
        summary: "Erro na validação",
        detail: "Selecione um item da Árvore do PTA para remover uma permissão",
      });
    }
  }

  async function adicionarPermissaoProgramaUOAsync(postBody) {
    try {
      await adicionarPermissaoUoPrograma(postBody);
      carregarPermissoes(ptaMonitoraSelecionado);
      return printToast({ severity: "success", summary: "Concluído", detail: "Permissão inserida com Sucesso" });
    } catch (err) {
      return printToast({
        severity: "error",
        summary: "Erro ao Adicionar Permissao",
        detail: err,
      });
    }
  }

  async function addPermissaoProgramaUO(tipoPermissao, tipoItem) {
    /*
      tipoPermissao => V = Visualização, E = Edição
      tipoItem => P = Programa,  UO = Unidade Orçamentária
    */

    if (usuarioSelecionado) {
      try {
        let idenPrograma = null;

        if (tipoItem === "UO") {
          idenPrograma = null;
        }

        if (tipoItem === "P") {
          idenPrograma = programaSelecionado.idenPrograma;
        }

        let postBody = {
          contaAcesso: {
            id: usuarioSelecionado.id,
          },
          uo: {
            idenUo: uoSelecionada.idenUo,
          },
          flagTipoPermissao: tipoPermissao,
          programa: {
            idenPrograma: idenPrograma,
          },
        };

        await adicionarPermissaoProgramaUOAsync(postBody);
        carregarPermissoes(ptaMonitoraSelecionado);
        printToast({ severity: "success", summary: "Concluído", detail: "Permissão inserida com Sucesso" });
      } catch (err) {
        return printToast({
          severity: "error",
          summary: "Erro ao Adicionar Permissao",
          detail: err,
        });
      }
      return null;
    } else {
      printToast({
        severity: "error",
        summary: "Erro na validação",
        detail: "Selecione um usuário para adicionar a permissão",
      });
    }
  }

  function onRowSelectUser(event) {
    if (event.data != null) {
      setUsuarioSelecionadoName(event.data.pessoa.nomePessoa);
      setExibirBuscaUsuario(false);
      setInputBusca("");
      setUsuariosBusca(null);
    } else {
      printToast({ severity: "error", summary: "Erro na validação", detail: "Erro na busca do usuário selecionado" });
    }
  }

  function onPageBuscaUsuario(event) {
    buscarUsuario(event.page, 10);
  }

  function onPageBuscaCdadosArvore(event) {
    buscarCdadosArvore(event.page, 10);
  }

  const itemNomeUsuarioTemplate = (node, column) => {
    return <span>{node.contaAcesso.pessoa.nomePessoa}</span>;
  };
  const itemPermissaoUsuarioTemplate = (node, column) => {
    return <span>{node.flagTipoPermissao === "V" ? "Visualização" : "Edição"}</span>;
  };
  const handleRowClick = (e, node) => {
    if (node?.key) {
      const newSelection = selectedNodeKeys.includes(node?.key)
        ? selectedNodeKeys.filter((key) => key !== node?.key)
        : [...selectedNodeKeys, node.key];
      setSelectedNodeKeys(newSelection);
    }
  };

  const itemArvoreTemplate = (node) => {
    return (
      <SelectableTreeNode
        node={node}
        selected={selectedNodeKeys}
        setSelectedNodeKeys={setSelectedNodeKeys}
        onRowClick={handleRowClick}
      />
    );
  };

  return (
    <CardSeplag title={"MONITORAMENTO : PERMISSÕES "}>
      <div className="p-fluid grid line-height-4">
        <div className="field col-12 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selExercicio">Exercício</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selExercicio"
                  value={exercicioSelecionado}
                  options={cDadosExercicios}
                  onChange={onChangeExercicio}
                  optionLabel="ano"
                  filter
                  showClear
                  filterBy="ano"
                  placeholder="Selecione um exercício"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selOrgao">Órgão</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selOrgao"
                  value={orgaoSelecionado}
                  options={cDadosOrgaos}
                  onChange={onChangeOrgao}
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Órgão"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selUO">U.O</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selUO"
                  value={uoSelecionada}
                  options={cDadosUOs}
                  onChange={onChangeUo}
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Selecione uma U.O."
                />
              </span>
            </div>
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12">
              <span>
                <label htmlFor="selPrograma">Programa</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selPrograma"
                  value={programaSelecionado}
                  options={cDadosProgramas}
                  onChange={onChangePrograma}
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Programa"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="card">
          <Message
            style={{ width: "100%", textAlign: "left" }}
            severity="warn"
            text="Selecione um item para atribuir/remover uma permissão"
          />
          <br />
          <TreeTable
            emptyMessage="Dados não encontrados"
            value={cDadosArvore && cDadosArvore.content ? cDadosArvore.content : []}
            lazy={true}
            selectionMode="single"
            selectionKeys={ptaMonitoraSelecionado}
            onRowClick={handleRowClick}
            onSelectionChange={(e) => buscarPtaMonitora(e.value)}
            onSelect={carregarPermissoes}
            paginator
            totalRecords={totalRecords}
            first={first}
            rows={rows}
            onPage={onPageBuscaCdadosArvore}
            loading={loading}
          >
            <Column
              field="descricaoItem"
              body={itemArvoreTemplate}
              style={{ textAlign: "justify", width: "68%", display: "flex", alignItems: "center" }}
              expander
              header="Descrição"
            />
          </TreeTable>
        </div>
        {ptaMonitoraSelecionado && (
          <>
            <Message
              style={{ width: "100%", textAlign: "left", fontWeight: "bold" }}
              severity="success"
              text={
                ptaMonitoraSelecionado.ptaFiplan.tipoItemPta.descTipoItemPta +
                ": " +
                ptaMonitoraSelecionado.ptaFiplan.descricaoFiplan
              }
            />
            <div className="card">
              <div className="p-fluid grid">
                <div className="field col-12 md:col-2">
                  <span>
                    <Button
                      type="button"
                      icon="pi pi-search"
                      label="Buscar"
                      className="p-button-success"
                      onClick={abrirBuscaUsuario}
                    ></Button>
                  </span>
                </div>
                <div className="field col-12 md:col-4">
                  <span>
                    <InputText
                      value={usuarioSelecionadoName}
                      placeholder="Selecione um usuário"
                      disabled
                      onChange={(e) => {
                        setUsuarioSelecionadoName(e.value);
                      }}
                    />
                  </span>
                </div>
                <div className="field col-12 md:col-3">
                  <span>
                    <SplitButton
                      type="button"
                      className="p-button-warning"
                      icon="pi pi-pencil"
                      model={itemsEdicao}
                      label="Permissão de Editar"
                      onClick={() => addPermissao("E")}
                    ></SplitButton>
                  </span>
                </div>
                <div className="field col-12 md:col-3">
                  <span>
                    <SplitButton
                      type="button"
                      className="p-button-info"
                      icon="pi pi-eye"
                      model={items}
                      label="Permissão de Visualizar"
                      onClick={() => addPermissao("V")}
                    ></SplitButton>
                  </span>
                </div>
              </div>
            </div>
            <DataTable
              value={usuarios}
              stripedRows={true}
              selectionMode="single"
              selection={usuarioSelecionado}
              onSelectionChange={(e) => setUsuarioSelecionado(e.value)}
              dataKey="idenPermissaoPtaMonitora"
              responsiveLayout="scroll"
            >
              <Column field="contaAcesso.pessoa.nomePessoa" body={itemNomeUsuarioTemplate} header="Nome"></Column>
              <Column body={itemPermissaoUsuarioTemplate} header="Permissao"></Column>
            </DataTable>
            <div className="p-fluid grid">
              <div className="field col-12">&nbsp;</div>
              <div className="field col-12 md:col-2">
                <span>
                  {usuarioSelecionado && (
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      label="Remover Permissão do Usuario"
                      className="p-button-danger"
                      onClick={() => rmvPermissao()}
                    ></Button>
                  )}
                  {!usuarioSelecionado && (
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      label="Remover Permissão do Usuario"
                      className="p-button-danger"
                      disabled
                    ></Button>
                  )}
                </span>
              </div>
            </div>
          </>
        )}
        <ModalSeplag
          tamanho="50rem"
          visible={exibirBuscaUsuario}
          titulo="Busca de Usuário"
          fechar={() => setExibirBuscaUsuario(false)}
          type="NONE"
        >
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 ">
              <div className="p-fluid grid line-height-4">
                <div className="field col-12 md:col-8 ">
                  <RotuloSeplag nome="Nome ( com no mínimo 3 letras )">
                    <InputText
                      type="text"
                      value={inputBusca}
                      placeholder="Digite o Nome, email ou CPF (sem pontos) do usuário"
                      onChange={(e) => {
                        setInputBusca(e.target.value);
                      }}
                    />
                  </RotuloSeplag>
                </div>

                <div className="field col-12 md:col-4 ">
                  <RotuloSeplag>
                    <Button
                      type="button"
                      icon="pi pi-search"
                      label="Buscar"
                      className="p-button-success"
                      onClick={() => {
                        buscarUsuario(0, 10);
                      }}
                    ></Button>
                  </RotuloSeplag>
                </div>
                {messagemUsuarioBusca && (
                  <div className="field col-12" style={{ textAlign: "center" }}>
                    Não foram encontrados usuários com os parâmetros informados
                  </div>
                )}
                {usuariosBusca && (
                  <DataTable
                    value={usuariosBusca.content}
                    stripedRows={true}
                    selectionMode="single"
                    selection={usuarioSelecionado}
                    paginator={true}
                    rows={10}
                    totalRecords={usuariosBusca.totalElements}
                    onPage={onPageBuscaUsuario}
                    lazy={true}
                    onSelectionChange={(e) => setUsuarioSelecionado(e.value)}
                    dataKey="id"
                    responsiveLayout="scroll"
                    onRowSelect={(e) => onRowSelectUser(e)}
                  >
                    <Column field="pessoa.nomePessoa" header="Nome"></Column>
                    <Column field="pessoa.cpfFormatado" header="CPF"></Column>
                    <Column field="pessoa.descEmail" header="Email"></Column>
                  </DataTable>
                )}
              </div>
            </div>
          </div>
        </ModalSeplag>
      </div>
    </CardSeplag>
  );
};

export default MonitoraPermissoes;
